export default {
  "b2b.fixniNaroky.nasledujiciWidgetTitle": "Fixní nároky",
  "b2b.fixniNaroky.nasledujiciWidgetTitleDescription": "NA NÁSLEDUJÍCÍ TÝDEN",
  "b2b.fixniNaroky.nasledujiciItemSmlouva": "Smlouva",
  "b2b.fixniNaroky.nasledujiciCountTitleVzo": "VZO",
  "b2b.fixniNaroky.nasledujiciCountTitleMzo": "MZO"
};
